import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import { RefreshIndicator } from "material-ui";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import environment from "../../relay/environment";
import SegmentDetail from "./SegmentDetail";

@connect(state => ({
  windowHeight: state.Responsive.get("windowHeight")
}))
class Renderer extends React.Component {
  static propTypes = {
    windowHeight: PropTypes.number.isRequired,
    match: PropTypes.shape({
      params: PropTypes.object
    }).isRequired
  };

  render() {
    const {
      windowHeight,
      match: {
        params: { segmentId }
      }
    } = this.props;
    const top = (windowHeight - 161) / 2 + 161;

    const loadingEl = (
      <RefreshIndicator top={top} left={900} status="loading" />
    );

    return (
      <QueryRenderer
        environment={environment}
        variables={{ segmentId }}
        query={graphql`
          query SegmentDetailRenderer_SegmentDetails_Query($segmentId: ID!) {
            allUsers {
              edges {
                node {
                  firstName
                }
              }
            }
            segment(id: $segmentId) {
              id
              name
              vendor {
                id
                name
                amenityPrograms
                contacts
              }
              dateString
              startDate
              endDate
              category
              bedType
              amenityProgram
              numAdults
              numChildren
              smokingRoom
              rates
              currency
              averageDailyRate
              cancellationDeadline
              dropbox
              invoiced
              vipDrafted
              booked
              cancelled
              sabreLocator
              confirmationNumber
              cancellationNumber
              vipLetter
              vipContext
              notes {
                id
                owner {
                  id
                  firstName
                }
                content
                created
              }
              trip {
                id
                searchId
                tripName
                primaryTravelerName
                destination
                dateString
                inquiry
                active
                cancelled
                inbox
                created
                modified
                tier
                fired
                lowPriority
                needsTraining
                needsVetting
                insideCircle
                vipNotes
                travelers {
                  id
                  fullName
                  firstName
                  lastName
                  birthdate
                  adult
                  vipNotes
                }
                notes {
                  owner {
                    id
                    firstName
                  }
                  content
                  created
                }
                segments {
                  id
                  name
                  dropbox
                  invoiced
                  vipDrafted
                  booked
                  cancelled
                }
              }
            }
          }
        `}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            const { segment, allUsers } = props;

            return <SegmentDetail segment={segment} users={allUsers} />;
          }

          return loadingEl;
        }}
      />
    );
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Segments/SegmentDetailRenderer.js